import { render } from "./MantList.vue?vue&type=template&id=598c03c3"
import script from "./MantList.vue?vue&type=script&lang=js"
export * from "./MantList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__